<template>
	<div class="input-group">
		<div class="custom-file">
			<input type="file" class="custom-file-input" ref="input" @change="onChange" :disabled="disabled" :multiple="multiple" :required="required">
			<label class="custom-file-label">
				{{ files && files.length > 0 ? Array.from(files).map(f => f.name).join(', ') : placeholder }}
			</label>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			placeholder: {
				type: String,
				required: false,
				default: 'Choose a file',
			},

			multiple: {
				type: Boolean,
				required: false,
				default: false,
			},

			required: {
				type: Boolean,
				required: false,
				default: false,
			},

			disabled: {
				type: Boolean,
				required: false,
				default: false,
			},
		},

		data() {
			return {
				files: [],
			};
		},

		methods: {
			onChange() {
				this.$emit('change', this.$refs.input.files);
				this.files = this.$refs.input.files;
			},
		},
	};
</script>